export class IPostTunningRequest{
  id?: string | null;
  createdAt?: string | null;
  ua?: string;
  browserName?: string;
  browserVersion?: string;
  engineName?: string;
  engineVersion?: string;
  osName?: string;
  osVersion?: string;
  deviceModel?: string;
  deviceType?: string;
  deviceVendor?: string;
  cpuArchitecture?: string;
  resultNetwork?: boolean;
  resultCamera?: boolean;
  resultMicrophone?: boolean;
  resultBrowser?: boolean;
  resultSpeakers?: boolean;
  connectionId?: string | null;
  attendant?: string | null;

  constructor(deviceInfo: IUAParserInfo, resultTest: IResultTest){
    if (deviceInfo) {
      this.id = null;
      this.createdAt = null;
      this.ua = deviceInfo.ua;
      this.browserName = deviceInfo.browser?.name;
      this.browserVersion = deviceInfo.browser?.version;
      this.engineName = deviceInfo.engine?.name;
      this.engineVersion = deviceInfo.engine?.version;
      this.osName = deviceInfo.os?.name;
      this.osVersion = deviceInfo.os?.version;
      this.deviceModel = deviceInfo.device?.model;
      this.deviceType = deviceInfo.device?.type;
      this.deviceVendor = deviceInfo.device?.vendor;
      this.cpuArchitecture = deviceInfo.cpu?.architecture;
      this.resultNetwork = resultTest?.resultNetwork;
      this.resultCamera = resultTest?.resultCamera;
      this.resultMicrophone = resultTest?.resultMicrophone;
      this.resultBrowser = resultTest?.resultBrowser;
      this.resultSpeakers = resultTest?.resultSpeakers;
      this.connectionId = null;
      this.attendant = null;
    }
  }
}
export class IPatchTunningRequest {
  id?: number;
  connectionId?: string;

  constructor(id?: number, connectionId?: string) {
    this.id = id;
    this.connectionId = connectionId;
  }
}
export interface IUAParserInfo{
  browser: {
    major: string;
    name: string;
    version: string;
  },
  cpu: {
    architecture: string;
  },
  device: {
    model: string;
    type: string;
    vendor: string;
  },
  engine:{
    name: string;
    version: string;
  },
  os: {
    name: string;
    version: string;
  }
  ua: string;
}

export interface IResultTest {
  resultNetwork: boolean;
  resultCamera: boolean;
  resultMicrophone: boolean;
  resultBrowser: boolean;
  resultSpeakers: boolean;
}
